<section class="auth-shell">

  <div class="auth-brand">
    <span class="word">Clug</span>
  </div>

  <div class="auth-card">
    <h1>Login to Your Account</h1>
    <p class="auth-sub">Use your email and password to login.</p>

    <div class="alert-box alert-error" role="alert" aria-live="polite" *ngIf="err">
      <i class="bi bi-exclamation-circle-fill"></i>
      <span class="alert-msg">{{ errDisplay }}</span>
      <button type="button" class="alert-close" (click)="err=''" aria-label="Dismiss error">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <div class="alert-box alert-success" role="status" aria-live="polite" *ngIf="emailSent">
      <i class="bi bi-check-circle-fill"></i>
      <span class="alert-msg">Reset link sent to {{ resetEmail || 'your inbox' }}. Check your inbox.</span>
      <button type="button" class="alert-close" (click)="emailSent=false" aria-label="Dismiss">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <form [formGroup]="loginForm" (ngSubmit)="login()" novalidate>

      <div class="field">
        <label for="email">Email <span class="req">*</span></label>
        <input type="text" id="email" class="input-form" formControlName="email" name="somethingAutofillDoesntKnow"
          autocomplete="email" [class.is-invalid]="(submitted || lForm['email'].touched) && lForm['email'].errors" />
        <div class="field-error" *ngIf="(submitted || lForm['email'].touched) && lForm['email'].errors">
          <i class="bi bi-exclamation-circle"></i>
          <span *ngIf="lForm['email'].errors['required']">Email is required.</span>
          <span *ngIf="lForm['email'].errors['email'] && !lForm['email'].errors['required']">Please enter a valid email
            address.</span>
        </div>
      </div>

      <div class="field">
        <label for="password">Password <span class="req">*</span></label>
        <div class="input-form-wrap">
          <input [type]="show ? 'text' : 'password'" id="password" class="input-form" formControlName="password"
            name="somethingAutofillDoesntKnow" autocomplete="current-password"
            [class.is-invalid]="(submitted || lForm['password'].touched) && lForm['password'].errors" />
          <button type="button" class="input-affix" (click)="show = !show"
            [attr.aria-label]="show ? 'Hide password' : 'Show password'">
            <i class="bi" [class.bi-eye]="show" [class.bi-eye-slash]="!show"></i>
          </button>
        </div>
        <div class="field-error" *ngIf="(submitted || lForm['password'].touched) && lForm['password'].errors">
          <i class="bi bi-exclamation-circle"></i>
          <span *ngIf="lForm['password'].errors['required']">Password is required.</span>
          <span *ngIf="lForm['password'].errors['minlength']">Password must be at least 6 characters.</span>
        </div>
      </div>

      <div class="auth-row">
        <label class="remember">
          <mat-checkbox [(ngModel)]="rememberMe" [ngModelOptions]="{standalone: true}"></mat-checkbox>
          <span>Remember me</span>
        </label>
        <a class="link-primary" role="button" tabindex="0" (click)="onForgotPassword()"
          (keyup.enter)="onForgotPassword()">
          Forgot password?
        </a>
      </div>

      <button class="btn btn-primary btn-block" type="submit" [disabled]="loading">
        <span class="auth-spinner" *ngIf="loading" aria-hidden="true"></span>
        <span *ngIf="!loading">Sign in</span>
        <span *ngIf="loading">Signing in…</span>
      </button>
    </form>
  </div>

  <!-- <div class="auth-foot">Need access? <a href="mailto:admin@clug.app">Contact your workspace admin.</a></div> -->
</section>